import { render, staticRenderFns } from "./NoticeForm.vue?vue&type=template&id=6525a9c2&scoped=true"
import script from "./NoticeForm.vue?vue&type=script&lang=js"
export * from "./NoticeForm.vue?vue&type=script&lang=js"
import style0 from "./NoticeForm.vue?vue&type=style&index=0&id=6525a9c2&prod&lang=less&scoped=true"
import style1 from "./NoticeForm.vue?vue&type=style&index=1&id=6525a9c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6525a9c2",
  null
  
)

export default component.exports